import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getBusinessPageData } from './api';
import type { BusinessModelPageDataLoadError } from './types';

export const {
	Context: BusinessPageDataContext,
	Provider: BusinessPageDataContextProvider,
	useContext: useBusinessPageData,
	useAsyncData: useBusinessPageDataFromApi,
	prefetchAsyncData: prefetchBusinessPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'BusinessModelPageDataContext',
	dataProperty: 'pageData',
	getData: getBusinessPageData,
	getUniqueId: ({ countryCode, locale }) => `${countryCode}:${locale}`,
	hookDeps: ({ countryCode, locale }) => [countryCode, locale],
	errorHandler: pageDataErrorHandler<BusinessModelPageDataLoadError>(),
});
